// request.ts puts the backend's message on err.message; the field it is about
// (and other details) stay on the axios response body.

interface ApiErrorBody {
  message?: string;
  type?: string;
  resend_in?: number;
}

export const apiErrorBody = (err: unknown): ApiErrorBody =>
  (err as { response?: { data?: ApiErrorBody } } | null)?.response?.data ?? {};

export const apiErrorMessage = (err: unknown, fallback: string): string =>
  err instanceof Error && err.message ? err.message : fallback;
